import { MaterialLayoutRenderer } from "@jsonforms/material-renderers";
import React from "react";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import { rankWith, uiTypeIs } from "@jsonforms/core";
import SFTypography from "../../typography";
import SFTooltip from "../../tooltip";
import { SFStack } from "../../grid";
import getStyled from "../../../hooks/getStyled";
import { useTranslation } from "react-i18next";
import { SFInfoIcon } from "../../icons";

const { styled } = getStyled();

const StyledSpan = styled("span")(() => ({
  alignItems: "center",
  display: "inline-flex",
  marginLeft: "5px",
}));
const StyledTypography = styled(SFTypography)(() => ({
  alignItems: "center",
  display: "inline-flex",
}));

const TextWithTooltipRenderer = (props) => {
  const { uischema, schema, path, visible, renderers } = props;
  const { t } = useTranslation();

  const layoutProps = {
    elements: uischema.elements,
    label: uischema.i18nKey ? t(uischema.i18nKey) : uischema.label,
    schema: schema,
    path: path,
    visible: visible,
    uischema: uischema,
    renderers: renderers,
    tooltipText: uischema.tooltipText,
  };

  return (
    <div>
      <SFStack>
        <StyledTypography variant="body1">
          {layoutProps.label}
          <SFTooltip width="narrow" content={layoutProps.tooltipText}>
            <StyledSpan>
              <SFInfoIcon size="small" color="grey450" />
            </StyledSpan>
          </SFTooltip>
        </StyledTypography>
      </SFStack>
      <MaterialLayoutRenderer {...layoutProps} />
    </div>
  );
};

export const TextWithTooltipTester = rankWith(1000, uiTypeIs("LabelTooltip"));

export default withJsonFormsLayoutProps(TextWithTooltipRenderer);
